export default "__VITE_ASSET__ab84b5c9__"